import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface AntiRollBarProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function AntiRollBar(props: AntiRollBarProps) {
  return (
    <svg
      width="166"
      height="234"
      viewBox="0 0 166 234"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 134, right: 221}}
      onClick={props.onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M153 1C159.627 1 165 6.37259 165 13C165 19.6274 159.627 25 153 25C133 59 131 59 131 77V157C131 175 133.08 175 153.08 209C159.671 209.043 165 214.399 165 221C165 227.627 159.627 233 153 233C146.373 233 141 227.627 141 221C141 218.657 141.673 216.471 142.834 214.623C139.834 209.623 134 200 131 196C128 192 126 189 114 189H54C49.0001 189 46.9999 191 41 197C37.6103 200.39 30.105 209.388 24.127 216.5C24.6895 217.89 25 219.409 25 221C25 227.627 19.6274 233 13 233C6.37258 233 1 227.627 1 221C1 214.373 6.37258 209 13 209C13.6019 209 14.1933 209.045 14.7715 209.131C21.028 201.516 30.7339 189.399 35 183C38.9999 177 39 162.913 39 159V75C39 71.0868 38.9999 56.9999 35 51C30.7339 44.6009 21.2565 32.4488 15 24.834C14.3496 24.9431 13.6814 25 13 25C6.37258 25 1 19.6274 1 13C1 6.37259 6.37258 1 13 1C19.6274 1 25 6.37259 25 13C25 14.6197 24.6793 16.1645 24.0977 17.5742C30.0757 24.6864 37.6104 33.6103 41 37C46.9999 42.9999 49.0001 45 54 45H114C126 45 128 42.0002 131 38C133.979 34.0283 139.718 24.4636 142.736 19.4336L142.801 19.3262C141.659 17.4896 141 15.3214 141 13C141 6.37259 146.373 1 153 1ZM57 56C55.0802 56 51 56.6 51 63V171C51 177.4 55.0802 178 57 178H109C118.6 178 119.333 168.333 119 163V71C119.333 65.6667 118.6 56 109 56H57Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M131 157C131 175 133.08 175 153.08 209C159.671 209.043 165 214.399 165 221C165 227.627 159.628 233 153 233C146.373 233 141 227.627 141 221C141 218.657 141.672 216.47 142.833 214.622C139.833 209.622 134 200 131 196C128 191.999 126 189 114 189H85.0003H54.0003C49.0003 189 47.0003 191 41.0003 197C37.6107 200.389 30.1058 209.387 24.1277 216.5C24.6903 217.889 25.0001 219.408 25.0001 221C25.0001 227.627 19.6275 233 13.0001 233C6.3727 233 1.00012 227.627 1.00012 221C1.00012 214.373 6.3727 209 13.0001 209C13.6021 209 14.1938 209.044 14.772 209.13C21.0286 201.515 30.7339 189.399 35 183C39 177 39 162.913 39 159V117V75.0002C39 71.0872 39 57.0002 35 51.0002C30.7339 44.601 21.2567 32.4489 15.0001 24.8341C14.3497 24.9432 13.6815 25 13.0001 25C6.3727 25 1.00012 19.6274 1.00012 13C1.00012 6.37259 6.3727 1 13.0001 1C19.6275 1 25.0001 6.37259 25.0001 13C25.0001 14.6198 24.6792 16.1647 24.0974 17.5744C30.0755 24.6868 37.6107 33.6105 41.0003 37.0001C47.0003 43.0001 49.0003 45.0001 54.0003 45.0001H85.0003H114C126 45.0001 128 42.0005 131 38.0003C133.979 34.0285 139.719 24.4624 142.736 19.4325L142.801 19.3255C141.659 17.4889 141 15.3214 141 13C141 6.37259 146.373 1 153 1C159.628 1 165 6.37259 165 13C165 19.6274 159.628 25 153 25C133 59 131 59 131 77V117V157Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M119 163V117V71C119.333 65.6667 118.6 56 109 56H57.0001C55.0803 56 51.0001 56.6 51.0001 63V117V171C51.0001 177.4 55.0803 178 57.0001 178H109C118.6 178 119.333 168.333 119 163Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M21.0001 13L17.0001 19.9282L9.00012 19.9282L5.00012 13L9.00012 6.0718L17.0001 6.0718L21.0001 13Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="13.0001"
        cy="13"
        r="4"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M161 13L157 19.9282L149 19.9282L145 13L149 6.0718L157 6.0718L161 13Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="153"
        cy="13"
        r="4"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M21.0001 221L17.0001 227.928L9.00012 227.928L5.00012 221L9.00012 214.072L17.0001 214.072L21.0001 221Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="13.0001"
        cy="221"
        r="4"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M161 221L157 227.928L149 227.928L145 221L149 214.072L157 214.072L161 221Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="153"
        cy="221"
        r="4"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
